import { createAction, props } from '@ngrx/store';
import {
  ImApplication,
  CatalogSlumpsResponse,
  ImSpacing,
  ImUnloadTime,
  ImUnloadType,
  ImSlump,
  ImLoadSize,
  TechnicalProductOP,
  ProductOP,
  IContact,
  ValueAddedOP,
  CombinationOP,
  UnitV2,
} from '@cemex-core/cmx-api';
import { ValueAddedTuple } from '../reducers/values-added.reducer';
import { ImFeature, ImPumpCapacity } from '@cemex-core/cmx-api/models/catalogs/catalogs-response';
import { IShipmentLocationWithFullAddress } from '@ordersnproducts/modules/shared/services/shipment-location-with-address';

export enum OrdersCatalogsActionTypes {
  LOAD_MIX = '[ORDERS CATALOGS] [Mix] Load',
  LOAD_MIX_SUCCESS = '[ORDERS CATALOGS] [Mix] Load Success',
  LOAD_APPLICATION = '[ORDERS CATALOGS] [Application] Load',
  LOAD_APPLICATION_COMPLETED = '[ORDERS CATALOGS] [Application] Load complete',
  LOAD_SPACING = '[ORDERS CATALOGS] [Spacing] Load',
  LOAD_SPACING_COMPLETED = '[ORDERS CATALOGS] [Spacing] Load complete',
  LOAD_UNLOAD_TIME = '[ORDERS CATALOGS] [Unload Time] Load',
  LOAD_UNLOAD_TIME_COMPLETED = '[ORDERS CATALOGS] [Unload Time] Load complete',
  LOAD_UNLOAD_TIME_FILTERED = '[ORDERS CATALOGS] [Unload Time] Load filtered values',
  LOAD_UNLOAD_TIME_FILTERED_COMPLETED = '[ORDERS CATALOGS] [Unload Time] Load filtered values complete',
  LOAD_UNLOAD_TYPE = '[ORDERS CATALOGS] [Unload Type] Load',
  LOAD_PUMP_CAPACITY = '[ORDERS CATALOGS] [Pump Capacity] Load',
  LOAD_UNLOAD_TYPE_PLANT = '[ORDERS CATALOGS] [Unload Type] Load plant catalog',
  LOAD_UNLOAD_TYPE_COMPLETED = '[ORDERS CATALOGS] [Unload Type] Load complete',
  LOAD_PUMP_CAPACITY_COMPLETED = '[ORDERS CATALOGS] [Pump Capacity] Load complete',
  CHANGE_UNLOAD_TIME = '[ORDERS CATALOGS] [Unload Time] change',
  CHANGE_UNLOAD_TIME_COMPLETE = '[ORDERS CATALOGS] [Unload Time] change complete',
  LOAD_SLUMP = '[ORDERS CATALOGS] [Slump] Load',
  LOAD_SLUMP_FILTERED = '[ORDERS CATALOGS] [Slump] Load filtered',
  LOAD_PUMPABILITIES = '[ORDERS CATALOGS] [Pumpability] Load',
  LOAD_PUMPABILITY_FILTERED = '[ORDERS CATALOGS] [Pumpability] Load filtered',
  LOAD_SLUMP_COMPLETED = '[ORDERS CATALOGS] [Slump] Load complete',
  LOAD_SLUMP_PRODUCT = '[ORDERS CATALOGS] [Slump product] Load',
  LOAD_SLUMP_PRODUCT_COMPLETED = '[ORDERS CATALOGS] [Slump product] Load complete',
  LOAD_LOAD_SIZE = '[ORDERS CATALOGS] [Load size] Load',
  LOAD_LOAD_SIZE_COMPLETED = '[ORDERS CATALOGS] [Load size] Load complete',
  LOAD_CONTACTS = '[ORDERS CATALOGS] [Contacts] Load',
  LOAD_CONTACTS_SUCCESS = '[ORDERS CATALOGS] [Contacts] Load Success',
  LOAD_VALUES_ADDED = '[ORDERS CATALOGS] [Values Added] Load added values not formulating',
  LOAD_VALUES_ADDED_MX = '[ORDERS CATALOGS] [Values Added] Load added values MX not formulating',
  LOAD_VALUES_ADDED_SUCCESS = '[ORDERS CATALOGS] [Values Added] Load complete',
  LOAD_POINT_OF_DELIVERY = '[ORDERS CATALOGS] [Point of Delivery] Load',
  LOAD_POINT_OF_DELIVERY_SUCCESS = '[ORDERS CATALOGS] [Point of Delivery] Load Success',
  POINT_OF_DELIVERY_ADD_ENTITY = '[ORDERS CATALOGS] [Point of Delivery] Add Entity',
  DUPLICATE_VALUE_ADDED_TUPLE_DATA = '[ORDERS CATALOGS] [Values Added] Duplicate Value Added Tuple Data',
  LOAD_FEATURE_TEMPERATURE = '[ORDERS CATALOGS] [Feature Temperature] Load',
  LOAD_FEATURE_TEMPERATURE_COMPLETED = '[ORDERS CATALOGS] [Feature Temperature] Load Complete',
  LOAD_FEATURE_ICE_QUANTITY = '[ORDERS CATALOGS] [Feature Ice Quantity]  Load',
  LOAD_FEATURE_ICE_QUANTITY_COMPLETED = '[ORDERS CATALOGS] [Feature Ice Quantity] Load Complete',
  RESET = '[ORDERS CATALOGS] [SingleCatalogs] Reset',
  RESET_VALUE_ADDED = '[ORDERS VALUE ADDED] Reset',
  ERROR = '[ORDERS CATALOGS] [SingleCatalogs] Error',
  PONT_OF_DELIVERY_DELETE_BY_ID = '[Point of delivery] DELETE BY ID',
  LOAD_FEATURE_PUMP_PRIMER = '[ORDERS CATALOGS] [Feature Pump Primer] Load',
  LOAD_FEATURE_PUMP_PRIMER_SUCCESS = '[ORDERS CATALOGS] [Feature Pump Primer] Load Success',
  REMOVE_VALUE_ADDED_INDEX_MX = '[ORDERS CATALOGS] [Values Added] Remove Value Added Index',
  LOAD_UNIT_BY_PRODUCT_MAP = '[ORDERS CATALOGS] [Unit By Product Map] Load',
  LOAD_UNIT_BY_PRODUCT_MAP_SUCCESS = '[ORDERS CATALOGS] [Unit By Product Map] Load Success',
  LOAD_UNIT_BY_PRODUCT_MAP_FAILURE = '[ORDERS CATALOGS] [Unit By Product Map] Load Failure',
}

export const LoadMix = createAction(OrdersCatalogsActionTypes.LOAD_MIX);

export const LoadMixSuccess = createAction(
  OrdersCatalogsActionTypes.LOAD_MIX_SUCCESS,
  props<{ payload: ProductOP[]; valuesAddedNotCombinable: CombinationOP[] }>(),
);

export const LoadApplicationCatalogAction = createAction(OrdersCatalogsActionTypes.LOAD_APPLICATION);

export const LoadApplicationCatalogCompleteAction = createAction(
  OrdersCatalogsActionTypes.LOAD_APPLICATION_COMPLETED,
  props<{ payload: ImApplication[] }>(),
);

export const LoadSpacingCatalogAction = createAction(OrdersCatalogsActionTypes.LOAD_SPACING);

export const ChangeUnloadTimeAction = createAction(
  OrdersCatalogsActionTypes.CHANGE_UNLOAD_TIME,
  props<{ payload: number }>(),
);

export const ChangeUnloadTimeCompleteAction = createAction(
  OrdersCatalogsActionTypes.CHANGE_UNLOAD_TIME_COMPLETE,
  props<{ payload: ImSpacing[] }>(),
);

export const LoadSpacingCatalogCompleteAction = createAction(
  OrdersCatalogsActionTypes.LOAD_SPACING_COMPLETED,
  props<{ payload: ImSpacing[] }>(),
);

export const LoadUnloadTimeCatalogAction = createAction(OrdersCatalogsActionTypes.LOAD_UNLOAD_TIME);

export const LoadUnloadTimeCatalogCompleteAction = createAction(
  OrdersCatalogsActionTypes.LOAD_UNLOAD_TIME_COMPLETED,
  props<{ payload: ImUnloadTime[] }>(),
);

export const LoadUnloadTimeFilteredCatalogAction = createAction(
  OrdersCatalogsActionTypes.LOAD_UNLOAD_TIME_FILTERED,
  props<{ payload: string }>(),
);

export const LoadUnloadTimeFilteredCompleteAction = createAction(
  OrdersCatalogsActionTypes.LOAD_UNLOAD_TIME_FILTERED_COMPLETED,
  props<{ payload: ImUnloadTime[] }>(),
);

export const LoadUnloadTypeCatalogAction = createAction(OrdersCatalogsActionTypes.LOAD_UNLOAD_TYPE);

export const LoadPumpCapacityCatalogAction = createAction(OrdersCatalogsActionTypes.LOAD_PUMP_CAPACITY);

export const LoadUnloadTypePlantCatalogAction = createAction(OrdersCatalogsActionTypes.LOAD_UNLOAD_TYPE_PLANT);

export const LoadUnloadTypeCatalogCompleteAction = createAction(
  OrdersCatalogsActionTypes.LOAD_UNLOAD_TYPE_COMPLETED,
  props<{ payload: ImUnloadType[] }>(),
);

export const LoadPumpCapacityCatalogCompleteAction = createAction(
  OrdersCatalogsActionTypes.LOAD_PUMP_CAPACITY_COMPLETED,
  props<{ payload: ImPumpCapacity[] }>(),
);

export const LoadSlumpCatalogAction = createAction(
  OrdersCatalogsActionTypes.LOAD_SLUMP,
  props<{ payload?: { productCode: string } }>(),
);

export const LoadSlumpFilteredCatalogAction = createAction(
  OrdersCatalogsActionTypes.LOAD_SLUMP_FILTERED,
  props<{ payload: TechnicalProductOP[] }>(),
);

export const LoadPumpabilityCatalogAction = createAction(OrdersCatalogsActionTypes.LOAD_PUMPABILITIES);

export const LoadPumpabilityFilteredCatalogAction = createAction(
  OrdersCatalogsActionTypes.LOAD_PUMPABILITY_FILTERED,
  props<{ payload: { id: number; name: string }[] }>(),
);

export const LoadSlumpCatalogCompleteAction = createAction(
  OrdersCatalogsActionTypes.LOAD_SLUMP_COMPLETED,
  props<{ payload: ImSlump[] }>(),
);

export const LoadSlumpProductCatalogAction = createAction(
  OrdersCatalogsActionTypes.LOAD_SLUMP_PRODUCT,
  props<{ productCode: string }>(),
);

export const LoadSlumpProductCatalogCompleteAction = createAction(
  OrdersCatalogsActionTypes.LOAD_SLUMP_PRODUCT_COMPLETED,
  props<{
    payload: {
      [productCode: string]: CatalogSlumpsResponse;
    };
  }>(),
);

export const LoadLoadSizeCatalogAction = createAction(OrdersCatalogsActionTypes.LOAD_LOAD_SIZE);

export const LoadLoadSizeCatalogCompleteAction = createAction(
  OrdersCatalogsActionTypes.LOAD_LOAD_SIZE_COMPLETED,
  props<{ payload: ImLoadSize[] }>(),
);

export const LoadContactsAction = createAction(OrdersCatalogsActionTypes.LOAD_CONTACTS);

export const LoadContactsSuccessAction = createAction(
  OrdersCatalogsActionTypes.LOAD_CONTACTS_SUCCESS,
  props<{ payload: IContact[] }>(),
);

export const LoadValuesAdded = createAction(
  OrdersCatalogsActionTypes.LOAD_VALUES_ADDED,
  props<{
    formId: number;
    productCode: string;
    contractCode: string;
    valueAddedIndex: number;
    valuesAdded?: ValueAddedOP[];
  }>(),
);

export const LoadValuesAddedMX = createAction(
  OrdersCatalogsActionTypes.LOAD_VALUES_ADDED_MX,
  props<{
    formId: number;
    productCode: string;
    contractCode: string;
    valueAddedIndex: number;
    valuesAdded?: ValueAddedOP[];
  }>(),
);

export const LoadValuesAddedSuccess = createAction(
  OrdersCatalogsActionTypes.LOAD_VALUES_ADDED_SUCCESS,
  props<{
    formId: number;
    productCode: string;
    contractCode: string;
    valueAddedIndex: number;
    valuesAdded: ValueAddedOP[];
    technicalProducts: TechnicalProductOP[];
  }>(),
);

export const DuplicateValueAddedTupleData = createAction(
  OrdersCatalogsActionTypes.DUPLICATE_VALUE_ADDED_TUPLE_DATA,
  props<{ key: string; tuple: ValueAddedTuple[] }>(),
);

export const SingleCatalogsResetAction = createAction(OrdersCatalogsActionTypes.RESET);

export const ResetValueAdded = createAction(OrdersCatalogsActionTypes.RESET);

export const SingleCatalogsErrorAction = createAction(OrdersCatalogsActionTypes.ERROR, props<{ payload: any }>());

export const LoadPointOfDeliveryAction = createAction(OrdersCatalogsActionTypes.LOAD_POINT_OF_DELIVERY);

export const LoadPointOfDeliverySuccessAction = createAction(
  OrdersCatalogsActionTypes.LOAD_POINT_OF_DELIVERY_SUCCESS,
  props<{ payload: IShipmentLocationWithFullAddress[] }>(),
);

export const PointOfDeliveryAddEntity = createAction(
  OrdersCatalogsActionTypes.POINT_OF_DELIVERY_ADD_ENTITY,
  props<{ payload: IShipmentLocationWithFullAddress }>(),
);

export const LoadFeatureTemperatureCatalogAction = createAction(OrdersCatalogsActionTypes.LOAD_FEATURE_TEMPERATURE);

export const LoadFeatureTemperatureCatalogCompletedAction = createAction(
  OrdersCatalogsActionTypes.LOAD_FEATURE_TEMPERATURE_COMPLETED,
  props<{ payload: ImFeature[] }>(),
);

export const LoadFeatureIceQuantityCatalogAction = createAction(OrdersCatalogsActionTypes.LOAD_FEATURE_ICE_QUANTITY);

export const LoadFeatureIceQuantityCatalogCompletedAction = createAction(
  OrdersCatalogsActionTypes.LOAD_FEATURE_ICE_QUANTITY_COMPLETED,
  props<{ payload: ImFeature[] }>(),
);

export const PointOfDeliveryDeleteById = createAction(
  OrdersCatalogsActionTypes.PONT_OF_DELIVERY_DELETE_BY_ID,
  props<{ payload: any }>(),
);

/**
 * Feature Pump Primer configurations such as Primer arrival time, max/min Primer quantity
 */
export const LoadFeaturePumpPrimerAction = createAction(OrdersCatalogsActionTypes.LOAD_FEATURE_PUMP_PRIMER);

export const LoadFeaturePumpPrimerSuccessAction = createAction(
  OrdersCatalogsActionTypes.LOAD_FEATURE_PUMP_PRIMER_SUCCESS,
  props<{ payload: ImFeature[] }>(),
);

export const RemoveValueAddedIndexMx = createAction(
  OrdersCatalogsActionTypes.REMOVE_VALUE_ADDED_INDEX_MX,
  props<{ formId: number; productCode: string; contractCode: string; valueAddedIndex: number }>(),
);

export const LoadProductUnitMappingAction = createAction(
  OrdersCatalogsActionTypes.LOAD_UNIT_BY_PRODUCT_MAP,
  props<{ payload: { productCode: string } }>(),
);

export const LoadProductUnitMappingSuccessAction = createAction(
  OrdersCatalogsActionTypes.LOAD_UNIT_BY_PRODUCT_MAP_SUCCESS,
  props<{ payload: { productCode: string; units: UnitV2[] } }>(),
);

export const LoadProductUnitMappingFailureAction = createAction(
  OrdersCatalogsActionTypes.LOAD_UNIT_BY_PRODUCT_MAP_FAILURE,
  props<{ payload: any }>(),
);

export const OrdersCatalogsActions = {
  LoadMix,
  LoadMixSuccess,
  LoadApplicationCatalogAction,
  LoadApplicationCatalogCompleteAction,
  LoadSpacingCatalogAction,
  LoadSpacingCatalogCompleteAction,
  LoadUnloadTimeCatalogAction,
  LoadUnloadTimeCatalogCompleteAction,
  LoadUnloadTimeFilteredCatalogAction,
  LoadUnloadTimeFilteredCompleteAction,
  LoadUnloadTypeCatalogAction,
  LoadPumpCapacityCatalogAction,
  LoadUnloadTypePlantCatalogAction,
  LoadUnloadTypeCatalogCompleteAction,
  LoadPumpCapacityCatalogCompleteAction,
  LoadSlumpCatalogAction,
  LoadSlumpCatalogCompleteAction,
  LoadSlumpProductCatalogAction,
  LoadSlumpProductCatalogCompleteAction,
  LoadPumpabilityCatalogAction,
  LoadPumpabilityFilteredCatalogAction,
  LoadLoadSizeCatalogAction,
  LoadLoadSizeCatalogCompleteAction,
  SingleCatalogsResetAction,
  ChangeUnloadTimeAction,
  ChangeUnloadTimeCompleteAction,
  LoadContactsAction,
  LoadContactsSuccessAction,
  LoadValuesAdded,
  LoadValuesAddedMX,
  LoadValuesAddedSuccess,
  DuplicateValueAddedTupleData,
  SingleCatalogsErrorAction,
  ResetValueAdded,
  LoadPointOfDeliveryAction,
  LoadPointOfDeliverySuccessAction,
  PointOfDeliveryAddEntity,
  LoadFeatureTemperatureCatalogAction,
  LoadFeatureTemperatureCatalogCompletedAction,
  LoadFeatureIceQuantityCatalogAction,
  LoadFeatureIceQuantityCatalogCompletedAction,
  PointOfDeliveryDeleteById,
  LoadFeaturePumpPrimerAction,
  LoadFeaturePumpPrimerSuccessAction,
  RemoveValueAddedIndexMx,
  LoadProductUnitMappingAction,
  LoadProductUnitMappingSuccessAction,
  LoadProductUnitMappingFailureAction,
};

export default OrdersCatalogsActions;
